import { render, staticRenderFns } from "./CrossLinkWidget.vue?vue&type=template&id=526c2df6&scoped=true"
import script from "./CrossLinkWidget.vue?vue&type=script&lang=js"
export * from "./CrossLinkWidget.vue?vue&type=script&lang=js"
import style0 from "./CrossLinkWidget.vue?vue&type=style&index=0&id=526c2df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526c2df6",
  null
  
)

export default component.exports